import { cn } from '@anytag/shared-utils';
import { useToggleState } from '@anytag/shared-hooks';
import { Icon } from '../Icon';
import { Input, InputProps } from './input';

export type InputPasswordProps = Omit<InputProps, 'type' | 'rightSection'>;

export const InputPassword = ({ classNames, ...restProps }: InputPasswordProps) => {
  const { status: isOpening, toggleStatus } = useToggleState(false);

  return (
    <Input
      {...restProps}
      type={isOpening ? 'text' : 'password'}
      classNames={{
        ...classNames,
        rightSection: cn({ 'pointer-events-auto cursor-pointer': !restProps.disabled }, classNames?.rightSection)
      }}
      rightSection={
        <Icon size="16px" variant="light-gray" onClick={toggleStatus} icon={isOpening ? 'eye' : 'eye-off'} />
      }
    />
  );
};
